import { render, staticRenderFns } from "./folder-restrictor.vue?vue&type=template&id=c73c1d64"
import script from "./folder-restrictor.vue?vue&type=script&lang=ts"
export * from "./folder-restrictor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports